{
  "name": "HS 12°-48° (Odd Partial Notation)",
  "description": "A two octave cycle comprising the harmonic partial row from 12° to 48°. 12° is mapped to MIDI Note 60 (Middle C), and tuned to 240 Hz, giving 1° = 20 Hz. The entire series may be transposed to any fundamental by changing the Reference Frequency, which (in this case) will set the pitch-class 3°. The first octave of the scale (12° to 24°) has 12 pitch-classes, and the second (24° to 48°) has 24, mapping onto 3 octaves of a conventional keyboard. The tones are notated as Odd Partial Pitch Classes.",
  "scale": [
    "13/12",
    "14/12",
    "15/12",
    "16/12",
    "17/12",
    "18/12",
    "19/12",
    "20/12",
    "21/12",
    "22/12",
    "23/12",
    "24/12",
    "25/12",
    "26/12",
    "27/12",
    "28/12",
    "29/12",
    "30/12",
    "31/12",
    "32/12",
    "33/12",
    "34/12",
    "35/12",
    "36/12",
    "37/12",
    "38/12",
    "39/12",
    "40/12",
    "41/12",
    "42/12",
    "43/12",
    "44/12",
    "45/12",
    "46/12",
    "47/12",
    "48/12"
  ],
  "key_colors_mode": "manual",
  "short_description": "36-HS_12to24",
  "built_in_group": "Harmonics and Subharmonics",
  "key_labels": "note_names",
  "fundamental_color": "#ffdbe8",
  "note_names": [
    "3",
    "13",
    "7",
    "15",
    "1",
    "17",
    "9",
    "19",
    "5",
    "21",
    "11",
    "23",
    "12",
    "25",
    "13",
    "27",
    "7",
    "29",
    "15",
    "31",
    "1",
    "33",
    "17",
    "35",
    "9",
    "37",
    "19",
    "39",
    "5",
    "41",
    "21",
    "43",
    "11",
    "45",
    "23",
    "47",
    "3"
  ],
  "note_colors": [
    "#ff9191",
    "#e6d7fe",
    "#ffe5e5",
    "#fffae5",
    "#ffffff",
    "#cfcfcf",
    "#ffffff",
    "#d6f7ff",
    "#fffae5",
    "#ffe5e5",
    "#dfffd6",
    "#95c69b",
    "#ffffff",
    "#fef5be",
    "#e6d7fe",
    "#ffffff",
    "#ffe5e5",
    "#8aafff",
    "#fffae5",
    "#68f3ec",
    "#ffffff",
    "#dfffd6",
    "#cfcfcf",
    "#ffcba8",
    "#ffffff",
    "#cee3e2",
    "#d6f7ff",
    "#e6d7fe",
    "#fffae5",
    "#f89b87",
    "#ffe5e5",
    "#c9a573",
    "#dfffd6",
    "#fffae5",
    "#95c69b",
    "#ffb8da"
  ],
  "equivSteps": 36,
  "fundamental": 240,
  "reference_degree": 0,
  "center_degree": 0,
  "rSteps": 4,
  "drSteps": 1,
  "hexSize": 38,
  "rotation": -16.102113751,
  "lumatone_anchor_note": 27,
  "lumatone_anchor_channel": 3
}
